import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { neuroLogicalStatusLeftOption, neuroLogicalStatusRightOption, vascularDoppler  } from './formFootOptions';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm';
import FootSensationDiagram from './FootSensationDiagram';


const NeurologicalStatus = (props) => {
    const {control, errors, getValues, setValue} = props

    const neurological = [
        {labelName:"Left",
        field_names: [
            {form_field_name:"neurological_status.neurological_left.pain_sensation",label:"Pain Sensation"},
            {form_field_name:"neurological_status.neurological_left.light_touch",label:"Light Touch"},
            {form_field_name:"neurological_status.neurological_left.temperature",label:"Temperature"},
            {form_field_name:"neurological_status.neurological_left.vibration_sensation",label:"Vibration Sensation"}],
            option:neuroLogicalStatusLeftOption },

        {labelName:"Right",
        field_names: [
            {form_field_name:"neurological_status.neurological_right.pain_sensation",label:"Pain Sensation"},
           {form_field_name:"neurological_status.neurological_right.light_touch",label: "Light Touch"},
           {form_field_name:"neurological_status.neurological_right.temperature", label: "Temperature"},
            {form_field_name:"neurological_status.neurological_right.vibration_sensation",label:"Vibration Sensation"}],
        option:neuroLogicalStatusRightOption },
    ]


   return (
    <ParentContainerSection heading="Section H - Assessment of neurological status">
            {neurological.length && neurological.map((item,index)=>(
                <InputContainer  sx={{ border:"1px solid", borderRadius:"12px" }}>
          <CustomInputLable required>{item.labelName}</CustomInputLable>
                <Box sx={{ display:"flex", flexDirection: "column", alignItems: "center", gap:"1rem", width:"100%",  }}>
                {item.field_names.map((fieldName, fieldIndex)=>(
                    <Box sx={{ display:"flex", alignItems: "center", gap:"1rem", width:"100%"}} key={fieldIndex}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", minWidth:"fit-content"}}>{fieldName.label}</InputLabelStyled>
                            <RadioButtonController
                                name={fieldName.form_field_name}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={item.option}
                                isDisabled
                            />
                    </Box>
                ))}
                </Box>
               
                </InputContainer>
        ))}
        <FootSensationDiagram control={control} errors={errors} getValues={getValues} setValue={setValue}/>
        </ParentContainerSection>
  )
}

export default NeurologicalStatus